export default __webpack_public_path__ + "static/B0297-bb2717f62b7bc950c569429183901f38.png";